module.exports = __webpack_public_path__ + "media/dorobek/assets/images/orcid-e690ef2f107673d7af9e899274dff0c3.png";